import { useRef } from 'react'
import { cloneDeep, isEqual } from 'lodash-es'

/**
 * Does a deep comparison of a value and only updates when the value changes.
 * Useful when you need to deep compare a hook dependency.
 */
export function useDeepCompareMemorize<T>(value: T): T {
  const ref = useRef<T>(value)
  if (!isEqual(value, ref.current)) {
    ref.current = cloneDeep(value)
  }
  return ref.current
}
